module.exports = __webpack_public_path__ + "static/media/vsprofile.62ae12c0.png";